import React from 'react';
import styles from './styles';
import { t } from 'src/i18n'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

const DefaultThankYouMessage = `The information you've entered was securely sent to our office.`;
const RefererMessage = `Please review and complete any additional documents that may require your attention.`;
const ReviewButtonMessage = `Review My Documents`;

const Referer = ({ referer }) => {
  return (
    <div style={styles.refererBlock}>
      <p style={{ ...styles.message, ...styles.messageSmall }}>{RefererMessage}</p>
      <a href={decodeURIComponent(referer)} className='btn btn-primary' style={styles.refererBtn}>
        {ReviewButtonMessage}
      </a>
    </div>
  );
};

const ThankYou = ({ message, referer }) => {
  return (
    <div style={styles.container}>
      <CheckCircleOutlineIcon
        style={{
          color: '#86C36F',
          fontSize: '72px',
          width: '100%',
          marginBottom: '15px',
        }}
      />
      <h1 style={styles.textThankYou}>{t('general.thankYou')}</h1>
      <p style={styles.message}>{message || DefaultThankYouMessage}</p>
      {referer && <Referer referer={referer} />}
    </div>
  );
};

ThankYou.defaultProps = {
  message: DefaultThankYouMessage,
};

export default ThankYou;
